import { render, staticRenderFns } from "./200625.vue?vue&type=template&id=6d88047a&scoped=true&"
import script from "./200625.vue?vue&type=script&lang=js&"
export * from "./200625.vue?vue&type=script&lang=js&"
import style0 from "./200625.vue?vue&type=style&index=0&id=6d88047a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88047a",
  null
  
)

export default component.exports